// TODO: Read up on this cache implementation is it in memory or indexeddb?
// Localtion is also not great.
// TODO: Typesafe IO implementation!
import { Cache } from "../../../../infra3d/utils/cache";
import { FrameV3 } from "./frame";
import { fetchAllData, fetchData, fetchDataAsGeoJSON, fetchAllDataAsGeoJSON } from "../util";
import proj4 from "proj4";
import { boundaryFilter, propertyFilter } from "../projectscope";
import wellknown from "wellknown";
function cacheKeyFrame(id, collection) {
    return `get(${id},${collection})`;
}
export class FrameProviderFramerV3 {
    constructor(apiHost, authObject, projectScope, cacheSize = 50000) {
        this._apiHost = new URL(apiHost);
        this._authObject = authObject;
        this._projectScope = projectScope;
        this._cache = new Cache(cacheSize, false);
    }
    allSequence(collection, sequence, onSuccess, onError) {
        try {
            const cacheKey = `allSequence(${collection}, ${sequence})`;
            const cached = this._cache.getItem(cacheKey);
            if (cached !== null) {
                onSuccess(cached);
                return;
            }
            const error = new Error("Data is invalid.");
            sequence = sequence.split("/")[1];
            const _propertyFilter = propertyFilter("frame", { sequence: sequence, projectScope: this._projectScope });
            const _boundaryFilter = boundaryFilter({ projectScope: this._projectScope });
            const url = `${this._apiHost.href}/frames/${collection}/query?${_propertyFilter}&limit=2000&order=timestamp`;
            const return_frames = (full_frames) => {
                const res = [];
                for (const frame of full_frames) {
                    if (frame === undefined) {
                        // FIXME: Why, this should never be the case.
                        continue;
                    }
                    if (!FrameV3.isValid(frame)) {
                        onError(error);
                        return;
                    }
                    const frame_v3 = FrameV3.create(frame);
                    const frame_v2 = FrameV3.FrameV3toV2(frame_v3, collection);
                    this._cache.setItem(cacheKeyFrame(frame_v2.id, collection), frame_v2, null);
                    res.push(frame_v2);
                }
                this._cache.setItem(cacheKey, res, null);
                onSuccess(res);
            };
            // FIXME: TRY
            fetchAllData(fetchData, url, "POST", (frames) => {
                if (frames === undefined || !Array.isArray(frames)) {
                    onError(error);
                    return;
                }
                return_frames(frames);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess([]);
                return;
            }
        }
    }
    allWithin(collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, onSuccess, onError) {
        try {
            const cacheKey = `allWithin(${collection}, ${minEasting}, ${maxEasting}, ${maxNorthing}, ${maxNorthing}, ${epsg})`;
            const cached = this._cache.getItem(cacheKey);
            if (cached !== null) {
                onSuccess(cached);
                return;
            }
            const error = new Error("Data is invalid.");
            const _propertyFilter = propertyFilter("frame", {
                projectScope: this._projectScope,
            });
            const _boundaryFilter = boundaryFilter({
                boundary: {
                    minEasting: minEasting,
                    maxEasting: maxEasting,
                    minNorthing: minNorthing,
                    maxNorthing: maxNorthing,
                    epsg: epsg,
                },
                projectScope: this._projectScope,
            });
            let url = `${this._apiHost.href}/frames/${collection}/query`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`?${_propertyFilter}`);
            }
            fetchAllData(fetchData, url, "POST", (frames) => {
                if (frames === undefined || !Array.isArray(frames)) {
                    onError(error);
                    return;
                }
                const res = [];
                for (const frame of frames) {
                    if (!FrameV3.isValid(frame)) {
                        onError(error);
                        return;
                    }
                    const frame_v3 = FrameV3.create(frame);
                    const frame_v2 = FrameV3.FrameV3toV2(frame_v3, collection);
                    this._cache.setItem(cacheKeyFrame(frame_v2.id, collection), frame_v2, null);
                    res.push(frame_v2);
                }
                this._cache.setItem(cacheKey, res, null);
                onSuccess(res);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess([]);
                return;
            }
        }
    }
    allWithinAsGeoJSON(collection, minEasting, maxEasting, minNorthing, maxNorthing, epsg, skip, limit, onSuccess, onError) {
        try {
            const cacheKey = `allWithinAsGeoJSON(${collection}, ${minEasting}, ${maxEasting}, ${maxNorthing}, ${maxNorthing}, ${epsg})`;
            const cached = this._cache.getItem(cacheKey);
            if (cached !== null) {
                onSuccess(cached);
                return;
            }
            const _propertyFilter = propertyFilter("frame", {
                projectScope: this._projectScope,
            });
            const _boundaryFilter = boundaryFilter({
                boundary: {
                    minEasting: minEasting,
                    maxEasting: maxEasting,
                    minNorthing: minNorthing,
                    maxNorthing: maxNorthing,
                    epsg: epsg,
                },
                projectScope: this._projectScope,
            });
            let url = `${this._apiHost.href}/frames/${collection}/query?srid=${epsg}&limit=${limit}`;
            if (_propertyFilter.length > 0) {
                url = url.concat(`&${_propertyFilter}`);
            }
            fetchAllDataAsGeoJSON(fetchDataAsGeoJSON, url, "POST", (geojson) => {
                this._cache.setItem(cacheKey, geojson, null);
                onSuccess(geojson);
            }, onError, this._apiHost.origin, this._authObject, { boundary: _boundaryFilter });
        }
        catch (error) {
            if (error.message === "No intersection of boundary") {
                onSuccess({
                    features: [],
                    type: "FeatureCollection",
                });
                return;
            }
        }
    }
    // TODO: TRY since its the same as capturesystemprovider as other gets.
    get(collection_fallback, key, onSuccess, onError) {
        const key_split = key.split("/");
        if (key_split.includes(collection_fallback)) {
            key_split.splice(0, 1);
        }
        key = key_split.join("/");
        const cacheKey = cacheKeyFrame(key, collection_fallback);
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        const url = `${this._apiHost.href}/frames/${collection_fallback}/${key}`;
        fetchData(url, "GET", (data) => {
            if (!FrameV3.isValid(data)) {
                onError(error);
                return;
            }
            const frame_v3 = FrameV3.create(data);
            const frame_v2 = FrameV3.FrameV3toV2(frame_v3, collection_fallback);
            this._cache.setItem(cacheKey, frame_v2, null);
            onSuccess(frame_v2);
        }, onError, this._authObject);
    }
    findNearest(collection, easting, northing, epsg, onSuccess, onError) {
        const cacheKey = `findNearest(${collection}, ${easting}, ${northing}, ${epsg})`;
        const cached = this._cache.getItem(cacheKey);
        if (cached !== null) {
            onSuccess(cached);
            return;
        }
        const error = new Error("Data is invalid.");
        if (epsg != 4326) {
            const lonlat = proj4(`EPSG:${epsg}`, "EPSG:4326", {
                x: easting,
                y: northing,
            });
            easting = lonlat.x;
            northing = lonlat.y;
        }
        const _propertyFilter = propertyFilter("frame", {
            projectScope: this._projectScope,
        });
        let boundaryString = "";
        if (this._projectScope?.boundaries) {
            const area_epsg = 4326;
            const wktString = wellknown.stringify(this._projectScope?.boundaries);
            boundaryString = `SRID=${area_epsg};${wktString}`;
        }
        // TODO: Extend framegate to also accept boundary-filter
        let url = `${this._apiHost.href}/frames/${collection}/knn/query?longitude=${easting}&latitude=${northing}`;
        if (_propertyFilter.length > 0) {
            url = url.concat(`&${_propertyFilter}`);
        }
        fetchAllData(fetchData, url, "POST", (frames) => {
            if (frames === undefined || !Array.isArray(frames)) {
                onError(error);
                return;
            }
            const res = [];
            for (const frame of frames) {
                if (!FrameV3.isValid(frame)) {
                    onError(error);
                    return;
                }
                const frame_v3 = FrameV3.create(frame);
                const frame_v2 = FrameV3.FrameV3toV2(frame_v3, collection);
                this._cache.setItem(cacheKeyFrame(frame_v2.id, collection), frame_v2, null);
                res.push(frame_v2);
            }
            this._cache.setItem(cacheKey, res, null);
            onSuccess(res);
        }, onError, this._apiHost.origin, this._authObject, boundaryString ? { boundary: boundaryString } : undefined);
    }
    clearCache() {
        this._cache.clear();
    }
    set authObject(authObject) {
        this._authObject = authObject;
    }
}
//# sourceMappingURL=frameprovider.js.map